import Vue from "vue";
import Component from "vue-class-component";
import ABaseComponent from 'Components/Base/ABaseComponent';
import { Prop } from "vue-property-decorator";


@Component({
    template: "#generic-information-modal-template"
})
export default class GenericInformationModalComponent extends ABaseComponent{
    @Prop()
    public modalId: string;
    @Prop()
    public message : string;
    @Prop()
    public headline: string;
    @Prop({ default: false })
    public useParentMessage: boolean;

    get getParentMessage() {
        var parent = this.$parent as any;

        return parent.getModalMessage;
    }
}
Vue.component('generic-info-modal', GenericInformationModalComponent); 